// Libraries
import { DefaultValue, selector } from "recoil";
// State
import { speciesListState, Species } from "state";

export const speciesActiveState = selector<Species | undefined>({
  key: "speciesActiveState",
  get: ({ get }) => {
    const animalTypes = get(speciesListState);

    return animalTypes?.find(({ active }) => active);
  },
  set: ({ get, set }, newSpecies) => {
    const speciesList = get(speciesListState);
    const newSpeciesList =
      newSpecies instanceof DefaultValue
        ? speciesList
        : speciesList?.map((species) => ({
            ...species,
            active: species.slug === newSpecies?.slug,
            slug: species.slug,
          }));

    set(speciesListState, newSpeciesList);
  },
});
